import React from "react";

// NavigationResult is used only for medium-confidence (non-auto) navigation, as
// an explicit "Go to" offer. Auto navigation happens in the controller.
export default function NavigationResult({ navigation, onGo = () => {} }) {
  if (!navigation) return null;
  return (
    <button type="button" onClick={() => onGo(navigation)} className="w-full text-left rounded-xl border border-card-bd bg-card p-4 hover:bg-surface-2">
      <div className="text-sm font-medium text-text">Go to {navigation.label}<span aria-hidden="true"> →</span></div>
      {navigation.reason && <div className="text-xs text-text-3 mt-1">{navigation.reason}</div>}
    </button>
  );
}
